import { Component, Injectable } from '@angular/core';
import { CodeSnippet } from './code-snippet.interface';


@Component({
    selector: 'add-for-loop-snippet',
    template: '',
    standalone: false
})
export class AddForLoopSnippet implements CodeSnippet{

    text : string = $localize`:@@script-editor.snippet.for:for`;

    static category: string = 'common';

    data: any;

    part = true;

    insert(): string | Promise<string> {
        return `
    for <counter_variable> = <initial_value>, <maximal_value> do 
        �-- your loop code here�
    end
`
    }
}